// src/utils/parseNumericField.js
//
// Shared numeric input coercion. Extracted from AddLocationModal during
// Slice L5 Gate 1 — EditLocationModal is the second caller and the M2
// backlog flagged this for promotion when a 2nd caller appeared.
//
// Returns a finite number for valid numeric input (incl. decimals and
// thousands separators), or null for empty / invalid. Routes ALL numeric
// inputs through here per Lesson 6 — never let NaN reach a server payload.

export function parseNumericField(v) {
  if (v == null) return null;
  const s = String(v).trim().replace(/,/g, "");
  if (s === "") return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}
